import React, { useEffect, useState } from "react";
import { axiosClient } from "../AxiosClient";
import { Avatar, Grid, ImageList, styled } from "@mui/material";
import { TIPOS_MENSAJES } from "../../Constants";
import DocumentIcon from "@mui/icons-material/PictureAsPdf";

const uploadImage = (keyImage, setImage) => {
  axiosClient
    .get(`/v1/s3/url/${keyImage}`)
    .then((response) => {
      setImage(response.data);
    })
    .catch((error) => {
      console.log("Error with Axios: " + error.message);
    });
};

const HoraStyled = styled("span")({
  color: "#aaa",
  fontSize: "10px",
  position: "absolute",
  marginTop: "190px",
  right: "5px",
});

export default function Document({ document, tipos, times }) {
  const [documentUrl, setDocumentUrl] = useState();

  useEffect(() => {
    uploadImage(document, setDocumentUrl);
  }, []);

  return (
    <Grid
      item
      sx={{
        display: "flex",
        justifyContent:
          tipos == TIPOS_MENSAJES.enviado ? "flex-start" : "flex-end",
        width: "100%",
      }}
    >
      <Grid sx={{ position: "relative", margin: "10px" }}>
        <img
          src={
            "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png"
          }
          width={"150px"}
          height={"180px"}
          alt="Document"
        />
        <HoraStyled>{times}</HoraStyled>
      </Grid>
    </Grid>
  );
}
